// Helpers for My Portal (and any public-token-based endpoint) so the
// session token issued by /api/public/mfa/verify gets sent on every
// subsequent request.
//
// Why the token: many browsers (Safari always; Chrome / Brave / Firefox
// with strict third-party cookie blocking) silently drop our SameSite=None
// cross-site MFA cookie. Without a fallback those users would never get
// past the MFA gate. The verify endpoint also returns a plaintext session
// token; we stash it in localStorage keyed by the person's availability
// token, then attach it as `?_s=...` on every public/* request. The
// backend's requireMfa middleware accepts EITHER the cookie OR the token.

const KEY = (personToken) => `mfa_session_${personToken}`;

export function setSessionToken(personToken, sessionToken) {
  if (!personToken || !sessionToken) return;
  try { localStorage.setItem(KEY(personToken), sessionToken); } catch (e) { /* ignore */ }
}

export function getSessionToken(personToken) {
  if (!personToken) return null;
  try { return localStorage.getItem(KEY(personToken)); } catch (e) { return null; }
}

export function clearSessionToken(personToken) {
  if (!personToken) return;
  try { localStorage.removeItem(KEY(personToken)); } catch (e) { /* ignore */ }
}

// Wrap fetch() so the stored session token is appended to public/* URLs.
// Also defaults credentials: 'include' so the cookie path keeps working
// on browsers that DO accept the cross-site cookie. Honours any opts.
//
// The personToken is extracted from the URL pathname — every public
// endpoint takes the availability token as a path segment, formatted as
// the standard 8-4-4-4-12 GUID. If we don't find one we just pass through.
export function publicFetch(url, opts = {}) {
  let finalUrl = url;
  try {
    const u = new URL(url);
    const m = u.pathname.match(/\/public\/[^?]*?\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/i);
    if (m) {
      const personToken = m[1];
      const sessionToken = getSessionToken(personToken);
      if (sessionToken) {
        u.searchParams.set('_s', sessionToken);
        finalUrl = u.toString();
      }
    }
  } catch (e) { /* malformed URL — fall through */ }
  return fetch(finalUrl, { credentials: 'include', ...opts });
}
